import React from 'react';
import { Text } from '@fluentui/react';
import styles from './DateDisplay.module.scss'

interface DateDisplayProps {
  date: string;
}

const DateDisplay: React.FC<DateDisplayProps> = ({ date }) => {
  return (
    <div className={styles.dateDisplay}>
      <Text className={styles.text} >{date}</Text>
    </div>
  );
};

export default DateDisplay;